<template>
	<section class="lockdown container">
    <h2 class="lockdown__title" @click="openModal">С 28 октября по 7 ноября Ауди Центр Север будет работать с соблюдением предписанных ограничений.
    <br>
    В эти дни мы продолжаем проводить ремонт и сервисное обслуживание, продавать и выкупать автомобили, а также оформлять страховые полисы в дистанционном формате.
  </h2>
    <div class="lockdown__full" v-if="modal" @click.self="closeModal">
      <div class="lockdown__info">
        Уважаемые клиенты,
        <br><br>С 28 октября по 7 ноября Ауди Центр Север будет работать с соблюдением предписанных ограничений.
        <br><br>В эти дни мы продолжаем проводить ремонт и сервисное обслуживание, продавать и выкупать автомобили, а также оформлять страховые полисы в дистанционном формате.
        <br><br>Обращаем ваше внимание, что шоурум в этот период будет закрыт для посещения, подробную информацию о покупке и сервисном обслуживании автомобилей вы сможете получить у наших сотрудников.
        <br><br>Мы социально ответственная компания, и для нас главным приоритетом является здоровье наших клиентов и сотрудников. Мы полностью поддерживаем меры, выработанные правительством страны для предотвращения распространения коронавирусной инфекции.
        <br><br>Не волнуйтесь, мы будем своевременно предоставлять Вам полную информацию о ходе оказания услуг или продаже автомобиля. Временные ограничения в работе дилерского центра никак не скажутся на качестве услуг нашей компании.

        <br><br>Мы ответим на любые Ваши вопросы по телефону: +7 (495) 785-27-27.

        <br><br>Ауди Центр Север с заботой о вашем здоровье.
        <div class="lockdown__close" @click="closeModal"></div>
      </div>
    </div>
	</section>
</template>

<script>
import Mixin from "../common/mixin";

export default {
	name: "block-lockdown",
	mixins: [Mixin],
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.lockdown {
  &__title {
    padding: 20px 0;
    text-align: center;
    font-size: 25px;
    cursor: pointer;
  }
  &__full {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(0,0,0, 0.5);
  }
  &__info {
    position: relative;
    padding: 20px;
    width: 80%;
    max-width: 800px;
    background: #fff;
  }
  &__close {
    position: absolute;
		background: url('../images/utils/close-black.svg') no-repeat center/contain;
    width: 20px;
    height: 20px;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
}

@media (max-width: 800px) {
	.lockdown {
		&__title {
			font-size: 18px;
		}
		&__info {
			width: 90%;
			height: 60%;
			overflow-y: scroll;
			font-size: 14px;
		}
	}
}
</style>
